import { z } from 'zod';

const permittedUserSchema = z.object({
  cd_usuario: z.number(),
  user_name: z.string(),
  user_email: z.string(),
});

export const pricingPermissionFormSchema = z.object({
  mode: z.enum(['ALL_USERS', 'SPECIFIC_USERS']),
  users: z.array(permittedUserSchema),
});

export type PricingPermissionFormValues = z.infer<typeof pricingPermissionFormSchema>;

export const selectUsersFormSchema = z.object({
  search: z.string(),
  selectedIds: z.array(z.number()),
});

export type SelectUsersFormValues = z.infer<typeof selectUsersFormSchema>;
